import { render, staticRenderFns } from "./AddCommAdrDlg.vue?vue&type=template&id=08b3c966&"
import script from "./AddCommAdrDlg.vue?vue&type=script&lang=js&"
export * from "./AddCommAdrDlg.vue?vue&type=script&lang=js&"
import style0 from "./AddCommAdrDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports